import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/myShopApi'
import mainStore from '@components/Main/store'

class Store {
  @observable list = []
  @observable droit = []
  @action
  getList = async () => {
    const {
      merchantInfo: {
        grade: { grade_level }
      }
    } = mainStore
    let { data } = await Api.privilege()
    runInAction(() => {
      for (let i = 0, len = data.length; i < len; i++) {
        if (data[i].level == grade_level) {
          this.list = data[i].privilege_list
        }
      }

      this.droit = data['4'].privilege_list
    })
  }
}
export default new Store()
